import React, {useContext, useState} from "react";
import {AlertContext} from "../AlertContex";
import {IThresholdParams, IDataPoint} from "@leap4/entities-discrepancy-common";
import {AlertTypes, apiClient, FormChips, Grid, Spinner, setAlert as setAlertFrontend, FormHelperText, TextField} from "@leap4/frontend";
import {urlService} from "../../../../../routing/urlsService";
import {useQuery} from "react-query";
import {AdServerTagsBaseUrl} from "../../../../../../config/generals";

export const ThresholdParamsForm = () => {
    const [data, setData] = useState<IDataPoint[]>([]);
    const {alert, setAlert} = useContext(AlertContext);
    const alertParams = alert.params as IThresholdParams;


    const updateAlertParams= (e) =>{
        setAlert({...alert, params: {...alert.params, [e.target.name]: e.target.value}})
    };

    const generateTagLink = (id) => {
        return urlService.adServerTag(id)
    }

    const updateSelectedTags = (selectedTags: string[]) => {
        const params = alert.params as IThresholdParams;
        params.tags = selectedTags
        setAlert({
            ...alert,
            params: params})
    }

    const fetchData =  async () => {
        try {
            const apiResponse = await apiClient.get(`${AdServerTagsBaseUrl}`, {params: {
                field: { name: 1 }
                }} )
            const apiData: any = apiResponse.data
            setData(apiData.results)
        } catch (err) {
            setAlertFrontend({msg: "Could not fetch data", type: AlertTypes.FAILURE})
        }
    };

    const {isLoading: isLoadingDataPoints} = useQuery(
        'threshold-get-data-points',
        fetchData,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            onError: (err: any) => setAlertFrontend({msg: err.message, type: AlertTypes.FAILURE})
        });

    return <>
        {isLoadingDataPoints ? <Spinner/> :
            <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
                <Grid item xs={3.8} md={3.8} style={{paddingTop: "10px"}}>
                    <FormChips
                        stackProps={{width: '100%', style: {margin: '20px 0'}}}
                        pureCreate={false}
                        enableCreate={false}
                        chips={alertParams?.tags}
                        inputName={"Tags"}
                        onUpdateItems={updateSelectedTags}
                        optionsList={data} valueKey={"_id"} labelKey={"name"}
                        link={generateTagLink}
                    />
                    <FormHelperText>
                        Impressions
                    </FormHelperText>
                    <TextField
                        fullWidth
                        value={alertParams?.impression}
                        onChange={updateAlertParams}
                        type="number"
                        InputProps={{ inputProps: { min: 100 } }}
                        size="small"
                        variant="outlined"
                        name="impression"
                        className={"gridItem"}
                    />
                </Grid>
            </Grid>
        }
    </>
}
